<template>
  <div>
    <img v-for="sub in orderedSubscribers"
         class="user-icon"
         :title="`${sub.user.fullname} (${sub.user.id === user.id ? sub.userFacingReason : sub.reason})`"
         :src="sub.user.iconUrl" />
    <p class="mt-2">
      <small v-if="userIsSubscribed">
        You're receiving notifications because {{userEntitySubscriber.userFacingReason}}.
        <br/>
        <a href="#" @click.prevent="unsubscribe">
          Unsubscribe
        </a>
      </small>
      <small v-else>
        <template v-if="userExplicitlyUnsubscribed">
          You unsubscribed.
        </template>
        <template v-else>
          You're not receiving notifications.
        </template>
        <br/>
        <a href="#" @click.prevent="subscribe">
          Subscribe
        </a>
      </small>
    </p>
  </div>
</template>

<script>
 import {showSuccess, showError} from 'perform-base/js/flashes';
 import axios from 'axios';

 export default {
   data() {
     const userEntitySubscriber = (() => {
       for (let sub of this.subscribers) {
         if (sub.user.id === this.user.id) {
           return sub;
         }
       }
       return null;
     })();

     return {
       // the EntitySubscriber for this user, can be null
       userEntitySubscriber
     };
   },

   props: [
     'user',
     'subscribers',

     // only one of these are required
     'postId',
     'taskId',
   ],

   computed: {
     userIsSubscribed() {
       return this.userEntitySubscriber && this.userEntitySubscriber.type !== -1;
     },
     userExplicitlyUnsubscribed() {
       return this.userEntitySubscriber && this.userEntitySubscriber.type === -1;
     },
     orderedSubscribers() {
       let subs = [];
       if (this.userIsSubscribed) {
         subs.push(this.userEntitySubscriber);
       }

       for (let sub of this.subscribers) {
         if (sub.user.id !== this.user.id) {
           subs.push(sub);
         }
       }

       return subs;
     },
   },

   methods: {
     subscribe() {
       this.updateSubscription(true);
     },
     unsubscribe() {
       this.updateSubscription(false);
     },
     updateSubscription(subscribed) {
       let data = {
         // 0 = TYPE_OPT_IN
         // -1 = TYPE_UNSUBSCRIBED
         type: subscribed ? 0 : -1,
       };

       if (this.postId) {
         data.postId = this.postId;
       } else if (this.taskId) {
         data.taskId = this.taskId;
       }

       axios
         .post('/entity-subscribe', data)
         .then(response => {
           this.userEntitySubscriber = response.data;
         })
         .catch(error => {
           console.error(error);
           showError(error.response.data.message);
         });
     }
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/EntitySubscribers.vue